import { SITE_MODE, SITE_MODES } from 'config/site-mode';

import { SHOPPING_CART_REDIRECT_URL } from 'config/shopping-cart';
import action from 'utils/action';
import { postShoppingCart } from 'services/shopping-cart';

const LOCAL_STORAGE_KEY_SHOPPING_CART_TOKEN = 'shoppingCartToken';

export function shoppingCartSetToken(payload) {
  return (dispatch) => {
    localStorage.setItem(LOCAL_STORAGE_KEY_SHOPPING_CART_TOKEN, payload);
    dispatch(action('SHOPPING_CART_SET_TOKEN', payload));
  };
}

function postXMLAndRedirect(url, data) {
  const form = document.createElement('form');
  document.body.appendChild(form);
  form.method = 'post';
  form.action = url;
  form.target = '_blank';
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'xml';
  input.value = data;
  form.appendChild(input);
  form.submit();
  document.body.removeChild(form);
}

export function shoppingCartSendProducts(projectId) {
  return (dispatch) => {
    dispatch(action('SHOPPING_CART_SEND_PRODUCTS_REQUEST'));
    const token = localStorage.getItem(LOCAL_STORAGE_KEY_SHOPPING_CART_TOKEN);
    if (SITE_MODE === SITE_MODES.RENSA && !token) {
      dispatch(action('SHOPPING_CART_SEND_PRODUCTS_FAILURE', 'no token provided'));
      return false;
    }
    return postShoppingCart(projectId, token).then(
      (response) => {
        if (response) {
          dispatch(action('SHOPPING_CART_SEND_PRODUCTS_SUCCESS'));

          if (SITE_MODE === SITE_MODES.TU) {
            if (response) {
              postXMLAndRedirect(SHOPPING_CART_REDIRECT_URL, response);
            } else {
              throw new Error('Error occured while exporting project');
            }
          }
          if (SITE_MODE === SITE_MODES.RENSA) {
            if (response.response.ok) {
              window.open(`${SHOPPING_CART_REDIRECT_URL}?token=${token}`, '_blank');
            }
          }
        } else {
          dispatch(
            action('SHOPPING_CART_SEND_PRODUCTS_FAILURE', 'Bad request'),
          );
        }
      },
      (error) => {
        dispatch(action('SHOPPING_CART_SEND_PRODUCTS_FAILURE', error.message));
      },
    );
  };
}



// WEBPACK FOOTER //
// ./js/actions/shopping-cart.js